import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { CompleteImages } from '../../../../_global/fragments/generated/CompleteImages';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ProjectForWorkspacesListFragment = { __typename?: 'Project', id: string, private: boolean, archivedAt?: string | null, name: string, images: { __typename?: 'Images', image32?: string | null, image64?: string | null, image128?: string | null, image256?: string | null, imageBase?: string | null, original?: string | null }, workspace?: { __typename?: 'Workspace', id: string, name: string } | null };

export const ProjectForWorkspacesList = /*#__PURE__*/ gql`
    fragment ProjectForWorkspacesList on Project {
  id
  private
  archivedAt
  images {
    ...CompleteImages
  }
  name
  workspace {
    id
    name
  }
}
    ${CompleteImages}` as unknown as DocumentNode<ProjectForWorkspacesListFragment, unknown>;

        

        
export const useProjectForWorkspacesListFragment = (
  input: string | Omit<UseFragmentOptions<ProjectForWorkspacesListFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<ProjectForWorkspacesListFragment>({
    fragment: ProjectForWorkspacesList,
    fragmentName: 'ProjectForWorkspacesList',
    ...options,
  });
};
  
        